/**
 * Created by jv on 20/01/2017.
 */
var tooltip = {};

(function(Tooltip)
{
  /*
   *  options.selector
   *  options.trigger
   *  options.title
   *  options.content
   *  options.placement
   */
  Tooltip.create = function(options)
  {
    $(options.selector).popover({
      content: options.content,
      title: options.title || "",
      placement: options.placement || "auto",
      trigger: options.trigger || "hover",
      html: true
    });
  };

  Tooltip.dispose = function(options)
  {
    try {
      $(options.selector).popover("dispose");
    }
    catch (e) {
      // ignore?: dispose sometimes gives nullpointer on removeChild //%TODO: find out why
    }

  }

}(tooltip));

module.exports = tooltip;



// WEBPACK FOOTER //
// ./app/js/components/tooltip.js